/**
 * AuditService
 */
angular.module('elogbooksServices').service('hierarchyService', function (lodash) {

    this.getJobGroupHierarchy = getJobGroupHierarchy;
    this.processHierarchy = processHierarchy;
    this.getIndentedHierarchy = getIndentedHierarchy;

    var itemValuePath = 'name';

    function getJobGroupHierarchy($collection, removePrefix = false) {

        var nofixed = processHierarchy($collection, null),
            prefixed = [];

        function processChildren(items, prefix) {

            prefix = prefix + ' / ';

            angular.forEach(items, function (value, index) {
                if(removePrefix) {
                    lodash.set(value, itemValuePath, lodash.get(value, itemValuePath));
                } else {
                    lodash.set(value, itemValuePath, prefix + lodash.get(value, itemValuePath));
                }

                prefixed.push(angular.extend({}, value, {isChild: true}));

                if (value.children.length) {
                    processChildren(value.children, lodash.get(value, itemValuePath));
                }
            });
        }

        angular.forEach(nofixed, function (value, index) {
            prefixed.push(value);
            if (value.children.length) {
                processChildren(value.children, lodash.get(value, itemValuePath));
            }
        });

        return prefixed;
    }

    function processHierarchy (collection, parent) {
        var items = [];

        angular.forEach(collection, function (value, index) {
            if ((value.getLink('parent') === null && ! parent) || value.getLink('parent') === parent) {
                var children = processHierarchy(collection, value.getLink('self'));

                items.push(angular.extend({}, value, {children: children}));
            }
        });

        return items;
    }

    function getIndentedHierarchy(collection) {
        var presentHrefs = {};
        angular.forEach(collection, function (item) {
            presentHrefs[item.getLink('self')] = true;
        });

        function buildIndented(items, parent, level) {
            var result = [];
            level = level || 0;
            angular.forEach(items, function (value) {
                var parentHref = value.getLink('parent');
                var isTopLevel = (parentHref === null || !presentHrefs[parentHref]);
                if ((isTopLevel && !parent) || parentHref === parent) {
                    var children = buildIndented(items, value.getLink('self'), level + 1);
                    var newValue = angular.extend({}, value, {children: children, level: level});
                    result.push(newValue);
                }
            });
            return result;
        }

        var indented = buildIndented(collection, null, 0);
        var flat = [];
        function flatten(items) {
            angular.forEach(items, function (item) {
                flat.push(item);
                if (item.children && item.children.length) {
                    flatten(item.children);
                }
            });
        }
        flatten(indented);
        return flat;
    }
});